module.exports = __webpack_public_path__ + "media/images/drops-4ae56beff1ead33f1c963c0744f4b5ba.png";